<template>
  <div class="background">
    <div class="opacity my-5">
      <mdb-card>
        <mdb-card-body>
          <mdb-card-title>
            <mdb-row class="my-1">
              <mdb-icon icon="user-tie" size="3x" class="mx-3 orange-text pr-2"/>
              <h3 class="h3 my-2">
                User Account
              </h3>
            </mdb-row>
          </mdb-card-title>
          <mdb-card-text>
            <mdb-row class="my-3 mx-1">
              <h5 class="h5 black-text">
                User Email:
              </h5>
              <span class="mx-3 my-1 grey-text">...Current User</span>
            </mdb-row>
          </mdb-card-text>
        </mdb-card-body>
        <mdb-btn color="orange"><mdb-icon icon="users-cog" class="mr-1 mx-2" size="2x"/>Change password</mdb-btn>
      </mdb-card>
    </div>
  </div>
</template>

<script>
import mdbBtn from 'mdbvue/lib/components/mdbBtn'
import mdbRow from 'mdbvue/lib/components/mdbRow'
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbCardBody from 'mdbvue/lib/components/mdbCardBody'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbCardText from 'mdbvue/lib/components/mdbCardText'
import mdbCardTitle from 'mdbvue/lib/components/mdbCardTitle'

export default {
  name: 'Basic',
  components: {
    mdbCard,
    mdbCardBody,
    mdbIcon,
    mdbRow,
    mdbBtn,
    mdbCardText,
    mdbCardTitle
  }
}
</script>

<style scoped>
.background{
background-image: url("~@/assets/profile.svg");
background-repeat: no-repeat;
background-size: contain;
background-attachment: fixed;
background-position: center;
-webkit-background-size: contain;
-moz-background-size: contain;
-o-background-size: contain;
padding-bottom: 300px;
height: 100%;
}
.opacity{
  opacity: 0.9;
}
</style>
